import { supabase } from '../supabase';

export const getLedgerEntries = async (fileOpeningId, { limit = 50, offset = 0, sortBy = 'date', sortOrder = 'asc' }) => {
    let query = supabase
        .from('ledger_entries')
        .select('*', { count: 'exact' })
        .eq('file_opening_id', fileOpeningId)
        .order(sortBy, { ascending: sortOrder === 'asc' })
        .range(offset, offset + limit - 1);

    const { data: entries, error, count } = await query;

    if (error) {
        throw new Error(error.message);
    }

    // Calculate running balance
    const entriesWithBalance = calculateRunningBalance(entries);

    return { entries: entriesWithBalance, count };
};

export const getAllLedgerEntries = async ({
    limit = 50,
    offset = 0,
    sortBy = 'date',
    sortOrder = 'desc',
    search = '',
    paymentMode = '',
    entryType = 'all',
    startDate = '',
    endDate = ''
}) => {
    let query = supabase
        .from('ledger_entries')
        .select('*', { count: 'exact' });

    if (search) {
        query = query.or(`name.ilike.%${search}%`);
    }

    if (paymentMode) {
        query = query.ilike('description', `%${paymentMode}%`);
    }

    if (entryType === 'in') {
        query = query.gt('credit', 0);
    } else if (entryType === 'out') {
        query = query.gt('debit', 0);
    }

    if (startDate) {
        query = query.gte('date', startDate);
    }

    if (endDate) {
        query = query.lte('date', endDate);
    }

    query = query
        .order(sortBy, { ascending: sortOrder === 'asc' })
        .range(offset, offset + limit - 1);

    const { data: entries, error, count } = await query;

    if (error) {
        throw new Error(error.message);
    }

    return { entries, count };
};

// Helper function to calculate running balance
const calculateRunningBalance = (entries) => {
    let balance = 0;
    return entries.map(entry => {
        const debit = parseFloat(entry.debit || 0);
        const credit = parseFloat(entry.credit || 0);

        // Only update balance if at least one of debit or credit is non-zero
        if (debit > 0 || credit > 0) {
            if (entry.type === 'invoice') {
                balance += debit; // Invoices add to balance
            } else if (entry.type === 'receipt') {
                balance -= credit; // Receipts subtract from balance
            }
        }
        // If both debit and credit are 0, balance remains the same (no change)

        return {
            ...entry,
            balance_amount: balance
        };
    });
};